import { hasCondition } from '@formio/js/utils';
import { useRef, useLayoutEffect } from 'react';
import { Form } from '@formio/react';

function FormViewer(props) {
  const { classes, form, onSubmit, options, setSize, submission } = props;
  const ref = useRef();
  const calculateSize = (nodes) => {
    const dimension = {
      height: 0,
      width: 0,
    };
    for (let i = 0; i < nodes.length; i++) {
      const nodeRect = nodes[i].getBoundingClientRect();
      dimension.height += nodeRect.height;
      dimension.width += nodeRect.width;
    }

    if (setSize) {
      setSize(dimension);
    }
    return;
  };

  useLayoutEffect(() => {
    const conditionalContent = (form?.components || [])
      .map((component) => hasCondition(component))
      .includes(true);

    if (!conditionalContent) {
      calculateSize([ref.current]);
    }
  });

  return (
    <div
      ref={ref}
      id="form-viewer"
      className={`form-viewer-container ${classes} no-print`}
    >
      <Form
        key={Date.now()}
        form={form}
        options={options}
        submission={submission}
        onSubmit={onSubmit}
      ></Form>
    </div>
  );
}

export default FormViewer;
